export const STERILISED = 'sterilised';
export const PREGNANT = 'pregnant';
export const LACTATION = 'lactation';
